exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2nhzB{height:271px;color:#fff;background:#646464}@media (max-width:480px){._2nhzB{height:auto}}._2bFCd{margin:0 auto;padding:25px 15px;max-width:1000px;text-align:center}._2bFCd h4{color:#fff;font-size:19.2px;font-size:1.2rem;text-transform:uppercase}._2bFCd ul{padding-left:0;list-style-type:none}._2bFCd ul li{margin:2px 0}._2bFCd a,._2bFCd a:active,._2bFCd a:focus,._2bFCd a:hover{color:#fff}._2bFCd ._3UIM1{margin-top:25px}._2bFCd ._3UIM1 a{display:inline-block;width:24px;width:1.5rem;height:24px;height:1.5rem;margin:0 5px;color:#646464;background:#fff;border-radius:50%}._2bFCd ._3UIM1 a:active,._2bFCd ._3UIM1 a:focus,._2bFCd ._3UIM1 a:hover{text-decoration:none}", ""]);

// exports
exports.locals = {
	"footer": "_2nhzB",
	"content": "_2bFCd",
	"socialMediaLinks": "_3UIM1"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/Footer/Footer.scss
// module id = 750
// module chunks = 2